// src/components/Products/ProductCard.jsx
import { useConfig } from "../../contexts/ConfigContext";
import ProductCardv1 from './Card/ProductCardv1';
import ProductCardv2 from './Card/ProductCardv2';

const ProductCard = ({
    product,
    prioritySpecialObject, // ADD this prop
    allSpecials = null,
    showMultipleSpecials = false,
    singleProductUrl,
    selectedVariant,
    setSelectedVariant,
    handleAddItem,
    variables,
    errors,
    isRelatedProducts,
    columns,
    menuSlug,
    handleVariantBoxSelection,
    handleVariantSelection,
    initialDisplayStyle,
    isFirstProduct = false,
}) => {
    const {
        themeConfig,
    } = useConfig();

    const commonProps = {
        product,
        prioritySpecialObject, // PASS this instead of specialId
        allSpecials,
        showMultipleSpecials,
        singleProductUrl,
        selectedVariant,
        setSelectedVariant,
        handleAddItem,
        handleVariantBoxSelection,
        handleVariantSelection,
        variables,
        errors,
        menuSlug,
        variantTheme: themeConfig?.productVariantsTheme,
        // Pass any other common props needed by both v1 and v2
        columns, // V1 uses it, V2 uses it
        isRelatedProducts, // V2 uses it
        initialDisplayStyle, // Pass if needed by v1 or v2
        isFirstProduct
    };

    return (
        <>
            {themeConfig.cardTheme && themeConfig.cardTheme === 'v1' ? (
                <ProductCardv1
                    {...commonProps}
                />
            ) : (
                <ProductCardv2
                    {...commonProps}
                />
            )}
        </>
    );
};

export default ProductCard;
